<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().passed" (change)="onPassedToggle($event)">Passed</mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().consider" (change)="onConsiderToggle($event)">Consider</mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().processing" (change)="onProcessingToggle($event)">Processing</mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().noVerification" (change)="onNoVerificationToggle($event)">No Verification</mat-slide-toggle>
</div>

<ng-container *ngIf="!getStateService().passed && !getStateService().consider && !getStateService().processing && !getStateService().noVerification">
    <div class="mt-2">
        <span style="color: red">*</span>&nbsp;<span class="text-muted">All filters inactive, <br />no guests will be displayed</span>
    </div>
</ng-container>